










import Vue from 'vue'
import { Component, Prop} from 'vue-property-decorator'

@Component<Intersectional>({})
export default class Intersectional extends Vue {
    @Prop(Function) public onUpperScrollEnd?: () => void
    @Prop(Function) public onMiddleEnter?: () => void
    @Prop(Function) public onMiddleExit?: () => void
    @Prop(Function) public onLowerScrollEnd?: () => void

    private upperObserver
    private middleObserver
    private lowerObserver

    public mounted() {
        this.upperObserver = new IntersectionObserver(entries => {
            this.handleUpperIntersection(entries[0])
        })

        this.upperObserver.observe(this.$refs.uptrigger)

        this.middleObserver = new IntersectionObserver(entries => {
            this.handleMiddleIntersection(entries[0])
        })

        this.middleObserver.observe(this.$refs.midtrigger)

        this.lowerObserver = new IntersectionObserver(entries => {
            this.handleLowerIntersection(entries[0])
        })

        this.lowerObserver.observe(this.$refs.lowtrigger)
    }

    public beforeDestroy() {
        if (this.upperObserver) {
            this.upperObserver.disconnect()
        }
        if (this.middleObserver) {
            this.middleObserver.disconnect()
        }
        if (this.lowerObserver) {
            this.lowerObserver.disconnect()
        }
    }

    private handleUpperIntersection(entry) {
        if (entry.isIntersecting && this.onUpperScrollEnd) {
            this.onUpperScrollEnd()
        }
    }

    private handleMiddleIntersection(entry) {
        if (entry.isIntersecting && this.onMiddleEnter) {
            this.onMiddleEnter()
        }
        if (!entry.isIntersecting && this.onMiddleExit) {
            this.onMiddleExit()
        }
    }

    private handleLowerIntersection(entry) {
        if (entry.isIntersecting && this.onLowerScrollEnd) {
            this.onLowerScrollEnd()
        }
    }
}

